import { render, staticRenderFns } from "./SpecialPrices.vue?vue&type=template&id=5a85b7c5&lang=pug"
import script from "./SpecialPrices.vue?vue&type=script&lang=js"
export * from "./SpecialPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports